module.exports = __webpack_public_path__ + "media/images/admin/icons/play-7c595cc952560306ed094adbc08d5de9.svg";